import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MarkPromoFlagSeenRequest, UserPromoFlagsService } from 'src/swagger/api.client.generated';

const HAS_VISITED_COMMUNITY_FLAG_KEY = 'HasVisitedCommunity';

/**
 * Account-level "has this user ever opened Community" signal (FLIP-323), so onboarding's
 * Community orientation step can skip itself for people who've already been there.
 *
 * Reuses UserPromoFlags (the same generic per-user FlagKey table CommunityPromoModalService
 * uses for FLIP-144) rather than a dedicated column - the table is a per-user seen-flag
 * store, and "has visited Community" is exactly that shape: one flag, written once,
 * idempotent on repeat writes.
 */
@Injectable({ providedIn: 'root' })
export class CommunityVisitService {
  constructor(private userPromoFlagsService: UserPromoFlagsService) {}

  /** Call once Community has actually loaded (e.g. CommunityComponent.ngOnInit). Idempotent. */
  markVisited(): void {
    this.userPromoFlagsService
      .markFlagSeen(new MarkPromoFlagSeenRequest({ flagKey: HAS_VISITED_COMMUNITY_FLAG_KEY }))
      .subscribe({ error: () => {} });
  }

  /** For onboarding to check at boot whether this account has ever visited Community. */
  hasVisited(): Observable<boolean> {
    return this.userPromoFlagsService
      .getSeenFlagKeys()
      .pipe(map((response) => (response.responseData ?? []).includes(HAS_VISITED_COMMUNITY_FLAG_KEY)));
  }
}
